import React from 'react';

const AdminHome = () => {
  return (
    <>
      <h2 className='admin-title'>Platform Admin</h2>
      <p className='admin-subtitle'>
        Home page placeholder. We will plug real metrics later.
      </p>
    </>
  );
};

export default AdminHome;
